import axios from "axios";
import { internal, urls } from "@/public/utils/env";
import appConfig from "@/public/globalConfig";
import { EDRAWMAX_PRODUCT_ENV, EDRAWMAX_PRODUCT_API, EDRAWMAX_WXREDIRECT } from "@/env/";
import { OSSAccessKeyId } from "./customVue.ts";
let { apiUrl, userUrl, masterURL, helpcenterUrl, goApiUrl } = urls;
import * as Sentry from "@sentry/vue";
import { Vue } from "@/public/utils/customVue";

let isProd; //是否为生产环境
if (typeof location != "undefined" && (~location.host.indexOf("10.") || ~location.host.indexOf("localhost"))) isProd = false;
if (typeof process != "undefined" && process.env.NODE_ENV === "production") isProd = true;
// isProd = false;
//是否运行在浏览器端
let isBrowserSide = typeof window !== "undefined" ? true : false;

// refresh
let isRefreshing = false;
let refreshPromise = null;
function refreshToken() {
    console.log("do refreshToken");
    const $edAuth = window["$edAuth"];
    if ($edAuth) {
        return $edAuth.getLastedToken();
    } else {
        return Promise.reject();
    }
}
function replaceToken(config, newToken) {
    let url = config.url;
    let header = config.headers;
    for (let name in header) {
        if (name == "Authorization") {
            header[name] = `Bearer ${newToken}`;
        }
    }
    if (/token/.test(url)) {
        // config.url = url.replace(/(?<=token\=).[^\&]*/, newToken)
        config.url = url.replace(/token\=.[^\&]*/, `token=${newToken}`);
    }
}
function retryRequest(config, userInfo) {
    replaceToken(config, userInfo.token);
    let tempAxios = axios.create();
    console.log("重新发送请求：" + config.url);
    return tempAxios(config);
}

let errorHandler = function (err) {
    if (err && err.response) {
        switch (err.response.status) {
            case 401:
                if (window.$qt) {
                    window.$qt.jsCallRefreshToken && window.$qt.jsCallRefreshToken();
                } else if (isBrowserSide) {
                    if (EDRAWMAX_PRODUCT_ENV === "workwx") {
                        location.href = EDRAWMAX_WXREDIRECT;
                    }
                    if (EDRAWMAX_PRODUCT_ENV === "private") {
                        location.href = `${location.origin}${appConfig.sourcePath}auth/auth.html`;
                    }
                    // app.$store.commit("invalidToken");
                    // // $edAuth.auth(()=>{window.location.href = window.location.href});
                    // if(!app.isPC){
                    //     app.$bus.$emit('login', 'token expire');
                    //     app.$store.commit('toPublicStatus', {
                    //         type: 'vip',
                    //         data: 0
                    //     })
                    // }
                    // app.$store.commit("showLogin", true);

                    if (!isRefreshing) {
                        // 存在问题，弱网下，当过期token业务请求未返回时，refreshToken刷新结束，仍有401请求会触发，造成多次刷新token
                        isRefreshing = true;
                        refreshPromise = refreshToken();
                        return refreshPromise
                            .then((userInfo) => {
                                app.$store.commit("setState", { type: "userInfo", data: userInfo });
                                isRefreshing = false;
                                return retryRequest(err.response.config, userInfo);
                            })
                            .catch(() => {
                                // 失败需要唤起登录
                                isRefreshing = false;
                                app.$store.commit("invalidToken");
                                if (!app.isPC) {
                                    app.$bus.$emit("login", "token expire");
                                    app.$store.commit("toPublicStatus", {
                                        type: "vip",
                                        data: 0,
                                    });
                                }
                            });
                    } else {
                        return refreshPromise.then((userInfo) => {
                            return retryRequest(err.response.config, userInfo);
                        });
                    }
                }
                break;
        }
    }
    Sentry.withScope((scope) => {
        if (err instanceof axios.Cancel) {
            return;
        }
        scope.setExtra("request_method", err.config?.method);
        scope.setExtra("request_url", btoa(err.config?.url));
        scope.setExtra("request_para_", err.config?.params);
        scope.setExtra("request_status", err.request?.status);
        scope.setExtra("request_statusText", btoa(err.request?.statusText));
        scope.setExtra("request_readyState", err.request?.readyState);
        if (err.response && err.response.request) {
            scope.setExtra("respon_data", btoa(err.response.request?.responseText));
        }
        Sentry.captureException(err);
    });
    return Promise.reject(err);
};

//!!!!!!!!!!!!!!!!!!!!!!测试
// let lang = 'zh'
let lang = appConfig.language;
let fileOssTimeout = 3 * 60 * 1000;

export default function edApi() {
    if (Vue.prototype.$edApi) {
        return Vue.prototype.$edApi;
    }

    let axIns, baseAxIns, masterAxios, ossAxIns, userDataIns, userAxIns, goApiAxios, goRiskAxios, fileOssAxIns;

    let basicAxIns = axios.create();
    let isPrivate = EDRAWMAX_PRODUCT_ENV == "private" || EDRAWMAX_PRODUCT_ENV == "workwx";

    if (isPrivate) {
        axIns = axios.create({
            baseURL: userUrl + "/api/user/",
            withCredentials: true,
        });
        baseAxIns = axios.create({
            baseURL: apiUrl + "/api/web/",
            withCredentials: true,
        });
        masterAxios = axios.create({
            // 待定
            baseURL: `${masterURL}/api/user/`,
            withCredentials: true,
        });
        ossAxIns = axios.create({
            baseURL: apiUrl + "/api/web/oss/",
            withCredentials: true,
            timeout: 15000,
            defaultInterceptors: true,
        });
        userDataIns = axios.create({
            baseURL: userUrl + "/api/user/user/",
            withCredentials: true,
        });
        if (!internal) {
            ossAxIns = axios.create({
                baseURL: apiUrl + "/api/web/aws/",
                withCredentials: true,
                defaultInterceptors: true,
            });
        }
        userAxIns = axios.create({
            baseURL: apiUrl + "/api/web/user/",
            withCredentials: true,
        });
        fileOssAxIns = axios.create({
            baseURL: window["GLOBAL"].PRIVATE_OSS_HOST,
        });
    } else {
        axIns = axios.create({
            baseURL: userUrl,
            withCredentials: true,
        });
        baseAxIns = axios.create({
            baseURL: apiUrl + "/api/",
            withCredentials: true,
        });
        masterAxios = axios.create({
            baseURL: `${masterURL}/api/user/`,
            withCredentials: true,
        });
        ossAxIns = axios.create({
            baseURL: apiUrl + "/api/oss/",
            withCredentials: true,
            timeout: 15000,
            defaultInterceptors: true,
        });
        userDataIns = axios.create({
            baseURL: userUrl + "/api/user/",
            withCredentials: true,
        });
        if (!internal) {
            ossAxIns = axios.create({
                baseURL: apiUrl + "/api/aws/",
                withCredentials: true,
                defaultInterceptors: true,
            });
        }
        userAxIns = axios.create({
            baseURL: apiUrl + "/api/user/",
            withCredentials: true,
        });
        fileOssAxIns = axios.create({
            baseURL: window["GLOBAL"].PRIVATE_OSS_HOST,
        });
        goApiAxios = axios.create({
            baseURL: goApiUrl + "/api/user/",
            withCredentials: false,
        });
        goRiskAxios = axios.create({
            baseURL: goApiUrl + "/api/risk/",
            withCredentials: false,
        });
    }
    baseAxIns.interceptors.request.use(
        (config) => {
            if (/get/i.test(config.method)) {
                //判断get请求
                config.params = config.params || {};
                config.params.t = Math.floor(new Date() / 1000); //添加时间戳
            }
            if (isPrivate) {
                let userInfo = app.$store.state.userInfo || app.$store.state.user.userInfo;
                if (userInfo && userInfo.token) {
                    config.headers.Authorization = `Bearer ${userInfo.token}`;
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    // 添加响应拦截器
    baseAxIns.interceptors.response.use((response) => response, errorHandler);

    userDataIns.interceptors.response.use((response) => response, errorHandler);
    userDataIns.interceptors.request.use(
        (config) => {
            if (/get/i.test(config.method)) {
                //判断get请求
                config.params = config.params || {};
                config.params.t = Date.parse(new Date()) / 1000; //添加时间戳
            }
            if (isPrivate) {
                let userInfo = app.$store.state.userInfo || app.$store.state.user.userInfo;
                if (userInfo && userInfo.token) {
                    config.headers.Authorization = `Bearer ${userInfo.token}`;
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // 添加响应拦截器
    ossAxIns.interceptors.response.use((response) => response, errorHandler);
    ossAxIns.interceptors.request.use(
        (config) => {
            if (/get/i.test(config.method)) {
                //判断get请求
                config.params = config.params || {};
                config.params.t = Date.parse(new Date()) / 1000; //添加时间戳
            }
            if (isPrivate) {
                let userInfo = app.$store.state.userInfo || app.$store.state.user.userInfo;
                if (userInfo && userInfo.token) {
                    config.headers.Authorization = `Bearer ${userInfo.token}`;
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // 添加响应拦截器
    userAxIns.interceptors.response.use((response) => response, errorHandler);
    userAxIns.interceptors.request.use(
        (config) => {
            if (/get/i.test(config.method)) {
                //判断get请求
                config.params = config.params || {};
                config.params.t = Date.parse(new Date()) / 1000; //添加时间戳
            }
            if (isPrivate) {
                let userInfo = app.$store.state.userInfo || app.$store.state.user.userInfo;
                if (userInfo && userInfo.token) {
                    config.headers.Authorization = `Bearer ${userInfo.token}`;
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    fileOssAxIns.interceptors.response.use((response) => response, errorHandler);
    fileOssAxIns.interceptors.request.use(
        (config) => {
            if (isPrivate) {
                let userInfo = app.$store.state.userInfo || app.$store.state.user.userInfo;
                if (userInfo && userInfo.token) {
                    config.headers.Authorization = `Bearer ${userInfo.token}`;
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    return {
        fileOssAxIns,
        // /api/user/:id/max/subscription?token=:token
        /**企业微信 */
        workwx_login(params) {
            return new Promise((resolve, reject) => {
                axIns
                    .post(`/user/wecom/login`, params)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        workwx_getCompanyMember(params) {
            let { id } = params;
            return userAxIns.get(`${id}/max/team/company/member`);
        },
        workwx_addCompanyMember(params) {
            let { id } = params;
            delete params.id;
            return userAxIns.post(`${id}/max/team/company/member`, params);
        },
        getRole(params) {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`/manager/${params.user_id}/role`, params)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getUserInfo(params) {
            let { id, token } = params;
            if (isPrivate) {
                return new Promise((resolve, reject) => {
                    userDataIns
                        .get(`/userinfo`, { user_id: id })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            let msg = err.response;
                            reject(msg);
                        });
                });
            }
            return new Promise((resolve, reject) => {
                userDataIns
                    .get(`${id}?token=${token}`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        uploadCustomTheme(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .put(`edmax/${id}/customtheme`, { name: "theme" }, { headers: { Authorization: "Bearer " + token } })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        downloadCustomTheme(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/${id}/customtheme?token=${token}`)
                    .then((response) => {
                        if (response.data) {
                            resolve(response.data);
                        } else {
                            reject();
                        }
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        searchLibraryIcon(params) {
            let { w, lang } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/libicon/search?w=${w}&lang=${lang}`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        uploadCustomLibrary(params) {
            let { id, token, targetUrl, symbol_key, type } = params.param;

            // TODO: SDK改造，上传我的库。原来的逻辑还存在上传到OSS的操作，应一并修改

            return new Promise((resolve, reject) => {
                let data = {
                    name: params.tableName,
                    size: params.size,
                    table_id: params.tableID,
                    lid: params.lid,
                    type: type,
                };
                if (isPrivate && symbol_key) {
                    Object.assign(data, { symbol_key });
                }
                baseAxIns
                    .put(`edmax/${id}/${targetUrl}`, data, {
                        headers: { Authorization: "Bearer " + token },
                    })
                    // axios
                    // .put(`https://test.edrawsoft.cn/viewer/public/api/edmax/${id}/${targetUrl}`, data, {headers: {Authorization: 'Bearer ' + token}})
                    .then((response) => {
                        if (response.data.status == "success") {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getCustomLibraryList(params) {
            // 获取云上的库列表
            let { id, token, type } = params;

            if (window.EDCONFIG.IS_SDK) {
                return new Promise((resolve, reject) => {
                    app.sdkApp
                        .promisePostMessage("GET_CUSTOM_LIB", { type })
                        .then((data) => {
                            resolve(data);
                        })
                        .catch((err) => {
                            reject(err.message);
                        });
                });
            }

            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/${id}/customlib?token=${token}&type=${type}`)
                    // baseAxIns
                    // .get(`https://test.edrawsoft.cn/viewer/public/api/edmax/${id}/customlib?token=${token}&type=${type}`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getCustomKey(params) {
            let { id, token, obj } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/${id}/customlib/obj?token=${token}&obj=${obj}`)
                    .then((response) => {
                        let key =
                            window["GLOBAL"].PRIVATE_OSS_HOST.indexOf("amazonaws") != -1
                                ? `${obj}?${response.data.data.query}`
                                : `${obj}?OSSAccessKeyId=${OSSAccessKeyId}&Expires=${response.data.data.exp}&Signature=${encodeURIComponent(
                                      response.data.data.sign
                                  )}`;

                        resolve(key);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getCustomLibarayKey(params) {
            // 用于下载文件
            let { id, token, obj, key } = params;
            let url = `edmax/${id}/customlib/obj?token=${token}&obj=${obj}`;
            if (isPrivate) {
                url += `&symbol_key=${key}`;
            }
            let ts = this;

            if (window.EDCONFIG.IS_SDK) {
                return app.sdkApp.promisePostMessage("GET_CUSTOM_LIB_OBJ", { obj });
            }

            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(url)
                    .then((response) => {
                        let key =
                            window["GLOBAL"].PRIVATE_OSS_HOST.indexOf("amazonaws") != -1
                                ? `${obj}?${response.data.data.query}`
                                : `${obj}?OSSAccessKeyId=${OSSAccessKeyId}&Expires=${response.data.data.exp}&Signature=${encodeURIComponent(
                                      response.data.data.sign
                                  )}`;
                        if (isPrivate) {
                            let d = response.data.data;
                            if (/\.edl$/.test(obj)) {
                                key = `${d.host}/${d.lable_path}?${d.lable_sign}`;
                            } else {
                                key = `${d.host}/${d.path}?${d.sign}`;
                            }
                        }

                        ts.fileOssAxIns
                            .get(key, { responseType: "blob" })
                            .then((e) => {
                                resolve(e);
                            })
                            .catch((err) => {
                                let msg = err.response;
                                reject(msg);
                            });
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        deleteCustomLibrary(params) {
            // 删除库
            let { id, token, libs, symbol_key } = params;
            let url = `edmax/${id}/customlib?libs[]=${libs}`;
            if (isPrivate) {
                url = `edmax/${id}/customlib?libs[]=${libs}&symbol_keys[]=${symbol_key}`;
            }
            return new Promise((resolve, reject) => {
                baseAxIns
                    .delete(url, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        updateCustomLibrary(params) {
            // 更新库
            let { id, token, lid, name, version, tableID, symbol_key } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(
                        `edmax/${id}/customlib`,
                        {
                            lid,
                            name,
                            version,
                            table_id: tableID,
                            symbol_key,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getRecycleData(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/max/recycled?token=${token}`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        delRecycleFolder(params) {
            let { folderId, id, token } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .delete(`${id}/max/recycled/${folderId}`, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        delRecycleFolderBatch(params) {
            // let {folderId,ids,token} = params;
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/batch/destroy`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        recycleFolderBatch(params) {
            // let {folderId,ids,token} = params;
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/batch/recv`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        recycleFolder(params) {
            let { folderId, id, token } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .put(
                        `${id}/max/recycled/${folderId}`,
                        {},
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getTemplateInfo(params) {
            let { tempInfo, class_id, type, sourceCancelToken } = params;
            let extra = sourceCancelToken ? { cancelToken: sourceCancelToken } : {};
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/${tempInfo}?class_id=${class_id}&type=${type}`, {
                        ...extra,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getEdrawTemplate(params) {
            return new Promise((rs, rj) => {
                baseAxIns
                    .get("edmax/template", {
                        params: {
                            tpl_id: params.tpl_id,
                        },
                    })
                    .then((res) => {
                        rs(res.data);
                    });
            });
        },
        searchTem(params) {
            let { name, offset, count, lang } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/template/search?name=${encodeURIComponent(name)}&offset=${offset}&count=${count}&lang=${lang}`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        searchTem2(params) {
            let { name, offset, count, lang } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/template/search2?name=${encodeURIComponent(name)}&offset=${offset}&count=${count}&lang=${lang}`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        setLang(params) {
            let { id, token, language } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(
                        `edmax/preference/${id}`,
                        { language },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getUserTempInfo(params) {
            let { id, tempInfo, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/attr/${tempInfo}?token=${token}`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        updateUserTempInfo(params) {
            let { id, tempInfo, tempId, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(
                        `${id}/attr/${tempInfo}`,
                        {
                            id: tempId,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        setStar(params) {
            let { id, token, start_tag, obj_id } = params;
            let p = { start_tag, obj_id };
            if (isPrivate) {
                Object.assign(p, {
                    file_key: params.file_key,
                });
            }
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/obj/start`, p, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getStarList(params) {
            let { id, token, start_tag, offset, count, platform } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/max/obj/start`, {
                        params: {
                            start_tag: start_tag || 1,
                            token,
                            offset,
                            count,
                            platform,
                        },
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getStarTag(params) {
            let { id, token, obj_id } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/max/obj/info`, {
                        params: params,
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        setCustomTag(params) {
            let { id, token, custom_tag, obj_id } = params;
            let p = {
                custom_tag,
                obj_id,
            };
            if (isPrivate) {
                Object.assign(p, {
                    file_key: params.file_key,
                });
            }
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/obj/customtag`, p, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        useTemplate(params) {
            let { id, tempId, token, platform } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(
                        `edmax/${id}/template/use`,
                        { platform, template_id: tempId },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getFolder(params) {
            let { prefix, id, token, version, platform } = params;
            return new Promise((resolve, reject) => {
                let url = `${id}/max?token=${token}&prefix=${prefix}`;
                url += version ? `&version=${version}` : "";
                url += platform ? `&platform=${platform}` : "";
                // let url = `${id}/max?token=${token}&prefix=${prefix}&version=${version}&platform=${platform}`
                ossAxIns
                    .get(url)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getFolders(params) {
            let { prefix, id, token, level } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/max/folder?token=${token}&prefix=${prefix}&max_level=${level}`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getFileForPublishModal(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/max?token=${token}`)
                    .then((response) => {
                        let data = response.data.data;
                        let fileList = [];
                        if (data.files) {
                            fileList = data.files.reduce((total, nowValue) => {
                                let list = nowValue.key.split("/");
                                let name = list[list.length - 1];
                                if (name.match(/(.*)\.eddx/)) {
                                    total.push({
                                        id: nowValue.info.id,
                                        name: name,
                                        key: nowValue.key,
                                        publish: nowValue.info.publish,
                                        updateTime: nowValue.lastModified,
                                        locked: nowValue.info.encrypt,
                                        edit: nowValue.info.edit,
                                    });
                                }
                                return total;
                            }, []);
                        }
                        let folderList = data.folders || [];
                        fileList.sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime());
                        resolve({
                            fileList,
                            folderList,
                        });
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getFolderForPublishModal(params) {
            let { prefix, id, token } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/max?token=${token}&prefix=${prefix}`)
                    .then((response) => {
                        let data = response.data.data;
                        let fileList = [];
                        if (data.files) {
                            fileList = data.files.reduce((total, nowValue) => {
                                let list = nowValue.key.split("/");
                                let name = list[list.length - 1];
                                if (name.match(/(.*)\.eddx/)) {
                                    total.push({
                                        id: nowValue.info.id,
                                        name: name,
                                        key: nowValue.key,
                                        publish: nowValue.info.publish,
                                        updateTime: nowValue.lastModified,
                                        locked: nowValue.info.encrypt,
                                        edit: nowValue.info.edit,
                                    });
                                }
                                return total;
                            }, []);
                        }
                        fileList.sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime());
                        let folderList = data.folders || [];
                        resolve({
                            fileList,
                            folderList,
                        });
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        searchFile(params) {
            let { id, token, platform } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/max/search?w=${params.w}&token=${token}&platform=${platform}`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        delFiles(params) {
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/recycled`, params, {
                        headers: { Authorization: "Bearer " + token },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        delFilesBatch(params) {
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/batch/del`, params, {
                        headers: { Authorization: "Bearer " + token },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        delFolder(params) {
            let { id, token, obj } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/recycled`, { obj }, { headers: { Authorization: "Bearer " + token } })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getDownFileAddress(params) {
            let { id, token, filePath } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/obj`, {
                        params: params,
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        privateGetDownFileAddress(params) {
            let { id, file_key } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/obj?file_key=${file_key}`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getDownFolderAddress(params) {
            //  /api/oss/{id}/max/dir/sign
            let { id, token, path } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/max/dir/sign?token=${token}&path=${encodeURIComponent(path)}`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getShareDownFileAddress(params) {
            let { id, token, uuid, obj, file_key, platform } = params;
            let url = `${id}/share/${uuid}/obj?token=${token}&obj=${encodeURIComponent(obj)}&platform=${platform}`;
            if (isPrivate) {
                url += `&file_key=${file_key}`;
            }
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(url)
                    .then((response) => {
                        if (response.data.msg === "Not exists") {
                            reject("notExist");
                        } else {
                            resolve(response.data);
                        }
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getTeamDownFileAddress(params) {
            let { id, token, teamId, objId, file_key } = params;
            let url = `${id}/max/team/${teamId}/obj/${objId}/sign?token=${token}}`;
            if (isPrivate) {
                url += `&file_key=${file_key}&team_id=${teamId}`;
            }
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(url)
                    .then((response) => {
                        console.log("response", response);
                        if (response.data.msg === "Not exists") {
                            reject("notExist");
                        } else {
                            resolve(response.data);
                        }
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getShareFileSign(params) {
            let { id, token, uuid, obj, platform } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(
                        `${id}/share/${uuid}/obj?token=${token}&platform=${platform}`,
                        {
                            obj,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.msg === "Not locked or locked by others") {
                            reject("notLocked");
                        } else if (response.data.msg === "Not allowed") {
                            reject("notAllowed");
                        } else if (response.data.msg === "Not exists") {
                            reject("notExist");
                        } else {
                            resolve(response.data);
                        }
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getTeamFileSign(params) {
            let { id, token, teamId, objId, file_key } = params;
            let p = {};
            if (isPrivate) {
                p = {
                    id,
                    team_id: teamId,
                    file_key: file_key,
                };
            }
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(`${id}/max/team/${teamId}/obj/${objId}/sign?token=${token}`, p, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        if (response.data.msg === "Not locked or locked by others") {
                            reject("notLocked");
                        } else if (response.data.msg === "Not exists") {
                            reject("notExist");
                        } else {
                            resolve(response.data);
                        }
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getCloudFileSign(params) {
            let { id, token } = params;
            let temp = { cfn: 1 };
            Object.assign(temp, params); // 设置检验非会员文件限制
            return new Promise((resolve, reject) => {
                ossAxIns
                    .put(`${id}/max`, temp, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err;
                        reject(msg);
                    });
            });
        },
        downloadOSSFile(params) {
            let { url, sign, exp, responseType } = params;
            let ts = this;
            return new Promise((resolve, reject) => {
                let downUrl;
                if (isPrivate) {
                    downUrl = `${encodeURIComponent(url)}?${sign}`;
                } else if (internal) {
                    downUrl = `${encodeURIComponent(url)}?OSSAccessKeyId=${OSSAccessKeyId}&Expires=${exp}&Signature=${encodeURIComponent(sign)}`;
                } else {
                    downUrl = `${encodeURIComponent(url)}?${sign}`;
                }
                ts.fileOssAxIns
                    .get(downUrl, { responseType })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        uploadOSSFile(params) {
            let { url, sign, exp, file, contentType } = params;
            let ts = this;
            return new Promise((resolve, reject) => {
                let upUrl;
                if (isPrivate) {
                    upUrl = `${url}?${sign}`;
                } else if (internal) {
                    upUrl = `${url}?OSSAccessKeyId=${OSSAccessKeyId}&Expires=${exp}&Signature=${encodeURIComponent(sign)}`;
                } else {
                    upUrl = `${url}?${sign}`;
                }
                ts.fileOssAxIns
                    .put(upUrl, file, {
                        headers: {
                            "Content-Type": contentType,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        addOpenRecord(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/obj/openrecord`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        deleteOpenRecord(params) {
            let { id, token, objId } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .delete(`${id}/obj/openrecord`, {
                        params: {
                            record_ids: objId,
                        },
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getOpenRecord(params) {
            let { id, token, platform } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${id}/obj/openrecord?token=${token}&platform=${platform}`)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getUserPrefer(params) {
            if (window.EDCONFIG.IS_SDK) {
                return app.sdkApp.promisePostMessage("GET_USER_PREFERENCE");
            }

            let { id } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/preference/${id}`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        updateUserPrefer(params) {
            if (window.EDCONFIG.IS_SDK) {
                return app.sdkApp.promisePostMessage("PUT_USER_PREFERENCE", params.obj);
            }

            let { id, token, obj } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(`edmax/preference/${id}`, obj, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        // 获取用户帮助
        getUserHelp(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`user/${id}/help?token=${token}`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        // 更新用户帮助
        updateUserHelp(id, token, obj) {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(`user/${id}/help`, obj, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        pushHisVersion(params) {
            let { user_id, token } = params;
            delete params.token;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(`${user_id}/max/objver`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        pushHisVersion2(params) {
            let { user_id, token } = params;
            delete params.token;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(`${user_id}/max/objver2`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        pushHisVersionCallback(params) {
            let { token, user_id } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(`${user_id}/max/objver2/callback`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getShareOpenList(params) {
            // http://10.10.17.37:8010/
            let { id, token, offset, count } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/max/share/opened?token=${token}&offset=${offset}&count=${count}`)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        //获取某个用户发布的所有作品
        getUserPublishWorks(params) {
            // /api/user/{id}/selfwork
            let { id, token, status, is_contain_edt } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get("user/" + id + "/selfwork", {
                        params: {
                            token,
                            status,
                            is_contain_edt,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        compareEtag(params) {
            let { id, token, uuid, etag } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/max/share/check/${uuid}?token=${token}&etag=${etag}`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getShareList(params) {
            let { id, token, fileType } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/max/share?token=${token}&type=${fileType}`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        cancelShare(params) {
            let { fileId, id, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .delete(`${id}/max/share/${fileId}`, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getShareUploadSign(params) {
            let { id, token, with_content } = params;
            let url = `${id}/public?token=${token}`;
            if (!internal) {
                url += `&with_content=${with_content}`;
            }
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(url)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getEditShareFileSign(params) {
            let { id, token, uuid } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(
                        `${id}/max/share/edit/${uuid}/svg`,
                        {},
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getUpdateShareFileSign(params) {
            let { id, token, shareId, with_content } = params;
            let url = `${id}/max/share/${shareId}/auth?token=${token}`;
            if (!internal) {
                url += `&with_content=${with_content}`;
            }
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(url)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        uploadShareFile(params) {
            let { url, data, fileType } = params; //此处url是绝对URL地址。
            return new Promise((resolve, reject) => {
                basicAxIns
                    .post(url, data, { headers: { "X-Requested-With": "XMLHttpRequest" } })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        privateUploadShareFile(params) {
            let ts = this;
            let { url, sign, exp, file, contentType } = params;
            return new Promise((resolve, reject) => {
                let upUrl = `${url}?${sign}`;
                ts.fileOssAxIns
                    .put(upUrl, file, {
                        headers: {
                            "Content-Type": contentType,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                    });
            });
        },
        shareFile(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(`${id}/max/share`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        updataShareFile(params) {
            let { id, token, shareId } = params;
            delete params.token;
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(`${id}/max/share/${shareId}`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        checkShareVerified(params) {
            let { id, token } = params;
            return new Promise((rs) => {
                userDataIns.get(`${id}/share/check?token=${token}`).then((res) => {
                    rs(res.data);
                });
            });
        },
        getSlideUploadSign(params) {
            // google slide
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                // axios
                // .get(`https://test.edrawsoft.cn/viewer/public/api/user/${id}/public?token=${token}`)
                baseAxIns
                    .get(`/user/${id}/public?token=${token}`)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        uploadSlideFile(params) {
            let { url, data } = params;
            return new Promise((resolve, reject) => {
                basicAxIns
                    .post(url, data, { headers: { "X-Requested-With": "XMLHttpRequest" } })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getInternetImage(params) {
            let { url } = params;
            return new Promise((resolve, reject) => {
                basicAxIns
                    .get(url, { responseType: "blob" })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        basicGet(params) {
            let { url } = params;
            return new Promise((resolve, reject) => {
                basicAxIns
                    .get(url)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getMaxConfig() {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/config`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getUserLimit(params) {
            let { id, token, platform } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`oss/${id}/max/obj/limit?platform=${platform}&token=${token}`)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getAllLibInfo() {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/alllib`)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        moveObj(params) {
            let { id, token } = params;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/obj/move`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        // 移动文件夹
        moveObjDir(params) {
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/dir/move`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        moveObjBatch(params) {
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/batch/move`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        copyObjDir(params) {
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/dir/copy`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        copyObjBatch(params) {
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/batch/copy`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        moveFolder(params) {
            let { id, token } = params;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${id}/max/dir/move`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        createFolder(params) {
            let { id, token, prefix } = params;
            delete params.token;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(
                        `${id}/max/obj`,
                        { prefix },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getSubscription(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                userDataIns
                    .get(`${id}/subscription/max?token=${token}`)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getVersionList(params) {
            if (window.EDCONFIG.IS_SDK) {
                return app.sdkApp.promisePostMessage("GET_VERSION_LIST");
            }

            let { obj, id, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/max/objver`, {
                        params: params,
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        editVersion(params) {
            if (window.EDCONFIG.IS_SDK) {
                return app.sdkApp.promisePostMessage("PUT_VERSION", params);
            }

            let { version_id, name, token, id } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(`${id}/max/objver`, params, {
                        headers: { Authorization: "Bearer " + token },
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        versionToNew(params) {
            let { version_id, token, id } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(`${id}/max/objver/branch`, params, {
                        headers: { Authorization: "Bearer " + token },
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        delVersion(params) {
            if (window.EDCONFIG.IS_SDK) {
                return app.sdkApp.promisePostMessage("DELETE_VERSION", params);
            }

            let { version_id, id, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .delete(`${id}/max/objver`, {
                        params: params,
                        headers: { Authorization: "Bearer " + token },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        backVersion(params) {
            let { version_id, id, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/max/objver/back`, {
                        params: params,
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },

        // commmunity realated
        getWorkInfo(params) {
            let { id, curFileKey: filePath, workId, rela, count, token, platform } = params;
            let param = { platform };
            if (workId) {
                //根据workId查作品发布信息的时候，传入的用户id是0，不需要token
                id = 0;
                param.work_id = workId;
                rela && (param.rela = rela);
                count && (param.count = count);
            } else {
                param.obj = filePath;
                param.token = token;
            }
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/work/info`, {
                        params: param,
                    })
                    .then((res) => {
                        if (res.data.msg == "not found") {
                            resolve(res.data.msg);
                        } else {
                            resolve(res.data.data);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        getWorkDownInfo(params) {
            let { id, workId, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/work/info?work_id=${workId}&token=${token}`)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        // 导入visio文件(未使用的旧接口)
        /**
         * @api {post} /api/user/{id}/maxfile/convert 文件转换
         * @apiGroup MaxFileConvert
         *
         * @apiParam {file} file
         * @apiParam {string} suffix 后缀，(.mmap|...)
         */
        convertFile(params) {
            let { id, token, file, suffix, to } = params;
            let form = new FormData();
            if (suffix) {
                form.append("suffix", suffix);
            } else if (to) {
                form.append("to", to);
            }
            form.append("file", file);
            return new Promise((resolve, reject) => {
                // axios.post(`http://10.10.17.39:8010/api/user/${id}/maxfile/convert`,form, {
                baseAxIns
                    .post(`user/${id}/maxfile/convert`, form, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((e) => {
                        resolve(e.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 导入visio文件(新)
        /**
         * @api {post} /api/user/{id}/maxfile/conversion 文件转换(导入和导出二合一，推荐)
         * @apiGroup MaxFileConvert
         *
         * @apiParam {file} file
         * @apiParam {string} suffix 后缀，导入用 vsdx|vsd
         * @apiParam {string} to 导出文件格式,导出用: vsdx|eddx|pdf|png
         */
        fileConversion(params) {
            let { id, token, file, suffix, to } = params;
            let form = new FormData();
            if (suffix) {
                form.append("suffix", suffix);
            } else if (to) {
                form.append("to", to);
            }
            form.append("file", file);
            return new Promise((resolve, reject) => {
                // axios.post(`http://10.10.17.39:8010/api/user/${id}/maxfile/fileConversion`, form, {
                baseAxIns
                    .post(`user/${id}/maxfile/conversion`, form, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((e) => {
                        resolve(e.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        /**
         * @api {get} /api/user/{id}/maxfile 获取文件
         * @apiGroup MaxFileConvert
         *
         * @apiParam {string} u
         */
        getConvertResult(params) {
            let { id, token, u } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`user/${id}/maxfile?token=${token}&u=${u}`)
                    .then((e) => {
                        // axios.get(`http://10.10.17.39:8010/api/user/${id}/maxfile?token=${token}&u=${u}`).then(e => {
                        resolve(e.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadConvertFile(params) {
            let { url } = params;
            return new Promise((resolve, reject) => {
                axios.get(url, { responseType: "blob" }).then((e) => {
                    resolve(e);
                });
            });
        },
        // 导出visio
        exportVisioFile(params) {
            let { id, token, file, to } = params;
            let form = new FormData();
            form.append("to", to);
            form.append("file", file);
            return new Promise((resolve, reject) => {
                // axios.post(`http://10.10.17.39:8010/api/user/${id}/maxfile/convert`,form, {
                baseAxIns
                    .post(`user/${id}/maxfile/export`, form, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((e) => {
                        resolve(e.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        //team related
        getTeamSpace(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(id + "/max/team/storage", {
                        params: {
                            user_id: id,
                            token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 获取团队列表
        getTeamList(params) {
            // userAxIns
            let { id, token } = params;
            return new Promise((resovle, reject) => {
                userAxIns
                    .get(id + "/max/team", {
                        params: {
                            token,
                        },
                    })
                    .then((res) => {
                        resovle(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 创建新的团队
        createNewTeam(params) {
            let { id, token, teamName } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(
                        id + "/max/team",
                        {
                            name: teamName,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        if (res.data.status == "success") {
                            resolve(res.data);
                        } else if (res.data.status == "error") {
                            if (res.data.msg == "team num over limit") {
                                reject("teamNumLimit");
                            } else {
                                reject(res.data.msg);
                            }
                        }
                    })
                    .catch((err) => {
                        const msg = err.response;
                        reject(msg);
                    });
            });
        },
        // 变更团队信息
        updateTeamInfo(params) {
            let { id, token, teamId, teamName } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(
                        `${id}/max/team/${teamId}`,
                        {
                            name: teamName,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        const msg = err.response;
                        reject(msg);
                    });
            });
        },
        // 获取团队文件
        getTeamFiles(params) {
            let { id, token, teamId } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(id + `/max/team/${teamId}/obj`, {
                        params: {
                            token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 新增团队文件
        importTeamFilesFromCloud(params) {
            let { id, token, teamId, obj_id, file_key } = params;
            let p = {
                obj_id,
            };
            if (isPrivate) {
                p = {
                    obj_id,
                    file_key,
                };
            }
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(id + `/max/team/${teamId}/import`, p, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        if (res.data.status == "success") {
                            resolve(res.data);
                        } else if (res.data.status == "error") {
                            if (res.data.msg == "storage space not enough") {
                                reject("noTeamSpace");
                            }
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 删除团队文件
        deleteTeamFile(params) {
            let { id, token, teamId, fileId, file_key } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .delete(`${id}/max/team/${teamId}/obj`, {
                        params: {
                            obj_id: fileId,
                            file_key: file_key,
                        },
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 获取团队成员
        getTeamMembers(params) {
            let { id, token, teamId } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(id + `/max/team/${teamId}/member`, {
                        params: {
                            token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        updateTeamMember(params) {
            let { id, token, teamId, userId, role } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(
                        `${id}/max/team/${teamId}/member/${userId}`,
                        {
                            role,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 生成邀请链接
        createTeamShareLink(params) {
            let { id, token, teamId, role } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(
                        id + "/max/team/" + teamId + "/share",
                        {
                            role,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        joinTeamByCode(params) {
            let { id, token, code } = params;
            return new Promise((resovle, reject) => {
                userAxIns
                    .get(`${id}/max/teamcode`, {
                        params: {
                            code,
                            token,
                        },
                    })
                    .then((res) => {
                        if (res.data.status == "success") {
                            resovle(res.data);
                        } else if (res.data.status == "error") {
                            if (res.data.msg == "team member num over limit") {
                                reject("memberNumLimit");
                            } else if (res.data.msg == "not found" || res.data.msg == "Invalid code") {
                                reject("ticketInvalide");
                            }
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        exitTheTeam(params) {
            let { id, token, teamId } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .delete(id + `/max/team/${teamId}/member/${id}`, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        deleteMember(params) {
            let { id, token, teamId, user_id } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .delete(id + `/max/team/${teamId}/member/${user_id}`, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 获取上传群文件需要用到的签名
        getTeamUploadSignature(params, fileInfo) {
            let { fileName, name, size } = fileInfo,
                { id, token, teamId } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(
                        id + `/max/team/${teamId}/obj`,
                        {
                            obj: fileName,
                            name: name,
                            size,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        if (res.data.status == "success") {
                            // let { exp, key, sign, img, img_sign } = res.data.data,
                            //     uploadPath = '', coverPath = '';
                            // if (internal) {
                            //     uploadPath = `${key}?OSSAccessKeyId=V4UkdUUAM3K63bGL&Expires=${exp}&Signature=${encodeURIComponent(sign)}`;
                            //     coverPath = `${img}?OSSAccessKeyId=V4UkdUUAM3K63bGL&Expires=${exp}&Signature=${encodeURIComponent(img_sign)}`
                            // } else {
                            //     uploadPath = '/' + key + "?" + sign;
                            //     coverPath = '/' + img + "?" + img_sign;
                            // }
                            resolve(res.data.data);
                        } else if (res.data.status == "error") {
                            reject(res.data.msg);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 修改群文件名称
        reTeamFileName(params) {
            let { id, token, teamId, obj_id, to, file_key, name } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(
                        id + `/max/team/${teamId}/obj`,
                        {
                            obj_id,
                            to,
                            file_key,
                            name,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        deleteTeam(params) {
            let { id, token, teamId } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .delete(id + `/max/team/${teamId}`, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 获取群文件编辑锁
        getEditTeamLock(params) {
            let { id, token, teamId, objId, file_key } = params;
            let url = `${id}/max/team/${teamId}/obj/${objId}/lock`;
            if (isPrivate) {
                url = `${id}/max/team/${teamId}/obj/${file_key}/lock`;
            }
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(
                        url,
                        {},
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        relEditTeamLock(params) {
            let { id, token, teamId, objId, file_key } = params;
            let url = `${id}/max/team/${teamId}/obj/${objId}/release/${token}`;
            if (isPrivate) {
                url = `${id}/max/team/${teamId}/obj/${file_key}/release/${token}`;
            }
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(url)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        // --------------------------------------发布------------------------------------
        getPublishLink(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/publish`, {
                        params: {
                            token: token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getUpdateLink(params) {
            let { id, token, workId } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .patch(`${id}/publish/${workId}`, {}, { headers: { Authorization: "Bearer " + token } })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        uploadFile(params) {
            let { url, data } = params; //此处url是绝对URL地址。
            return new Promise((resolve, reject) => {
                basicAxIns
                    .post(url, data, { headers: { "X-Requested-With": "XMLHttpRequest" } })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getUploadSign(params) {
            // 获取上传的签名
            // /api/manager/{id}/work/{work_id}/obj?token=:token
            let { id, token, work_id, file, fileName } = params; //此处url是绝对URL地址。
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`manager/${id}/work/${work_id}/obj?token=${token}`)
                    .then((response) => {
                        let resData = response.data.data;
                        resolve(resData);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        publishFile(params) {
            let { id, token, data } = params; //此处url是绝对URL地址。
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(`${id}/publish`, data, { headers: { Authorization: "Bearer " + token } })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        if (err.response.data.title) {
                            // err.response.data.title:["The title may not be greater than 255 characters."]
                            if (err.response.data.title[0] == "The title may not be greater than 255 characters.")
                                reject({
                                    msg: "title over 255 characters",
                                });
                            else if (err.response.data.title == "ERR_ILLEGALWORD")
                                reject({
                                    msg: "title ERR_ILLEGALWORD",
                                    words: err.response.data.censor_word,
                                });
                        } else if (err.response.data.description) {
                            // err.response.data.description:["The description may not be greater than 255 characters."]
                            if (err.response.data.description[0] == "The description may not be greater than 255 characters.")
                                reject({
                                    msg: "description over 255 characters",
                                });
                            else if (err.response.data.description == "ERR_ILLEGALWORD")
                                reject({
                                    msg: "description ERR_ILLEGALWORD",
                                    words: err.response.data.censor_word,
                                });
                        }
                        reject(err);
                    });
            });
        },
        //删除发布作品
        // /api/user/:id/work/{work_id}
        deletePublish(params) {
            let { id, token, workId } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .delete(`${id}/work/${workId}`, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        tempBindPhone(params) {
            let { id, token, data } = params;
            return userAxIns.post(`${id}/work/verify`, data, {
                headers: {
                    Authorization: "Bearer " + token,
                },
            });
        },
        updatePublish(params) {
            let { id, token, data } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(`${id}/work/${data.workId}`, data, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve();
                    })
                    .catch((err) => {
                        if (err.response.data.title) {
                            // err.response.data.title:["The title may not be greater than 255 characters."]
                            if (err.response.data.title[0] == "The title may not be greater than 255 characters.")
                                reject({
                                    msg: "title over 255 characters",
                                });
                            else if (err.response.data.title == "ERR_ILLEGALWORD")
                                reject({
                                    msg: "title ERR_ILLEGALWORD",
                                    words: err.response.data.censor_word,
                                });
                        } else if (err.response.data.description) {
                            // err.response.data.description:["The description may not be greater than 255 characters."]
                            if (err.response.data.description[0] == "The description may not be greater than 255 characters.")
                                reject({
                                    msg: "description over 255 characters",
                                });
                            else if (err.response.data.description == "ERR_ILLEGALWORD")
                                reject({
                                    msg: "description ERR_ILLEGALWORD",
                                    words: err.response.data.censor_word,
                                });
                        }
                        reject(err);
                    });
            });
        },

        // 后台
        setFileEncryptStatus(params) {
            if (window.EDCONFIG.IS_SDK) return;

            let { id, token, data } = params;
            return new Promise((rs, rj) => {
                userAxIns
                    .post(`${id}/obj/encrypt`, data, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        rs(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        rj(msg);
                    });
            });
        },
        checkNewMsg(params) {
            let { id, token } = params;
            return new Promise((rs, rj) => {
                userDataIns
                    .get(`${id}/notification/exists?token=${token}`)
                    .then((response) => {
                        rs(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        rj(msg);
                    });
            });
        },
        // 获取通知消息
        getNotifiedMsg(params) {
            let { offset, count, id, token } = params;
            return new Promise((rs, rj) => {
                userDataIns
                    .get(`${id}/notification?offset=${offset}&count=${count}&token=${token}`)
                    .then((response) => {
                        let unReadList = response.data.data.notify.filter((v, k) => {
                            return v.is_read == 0;
                        });
                        let ids = unReadList.map((v) => v.id);
                        // let obj = {
                        //     id,
                        //     token,
                        //     ids
                        // }
                        response.data.hasUnreadMsg = ids.length > 0;
                        // ids.length > 0 && this.setIsRead(obj); // 设置消息为已读
                        rs(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        rj(msg);
                    });
            });
        },
        setIsRead(params) {
            let { id, token, ids } = params;
            return new Promise((resolve, reject) => {
                userDataIns
                    .put(
                        `${id}/notification`,
                        { ids },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },

        //获取待审核文件
        // /api/user/{user_id}/review
        getPublishReview(data) {
            let { id, token, lang } = data;
            return new Promise((resolve, reject) => {
                let url = `manager/${id}/review?token=${token}`;
                if (lang) {
                    url = `${url}&lang=${lang}`;
                }
                baseAxIns
                    .get(url, {
                        params: data.data,
                    })
                    .then((res) => {
                        let data = res.data.data;
                        resolve({ data, total: res.data.msg });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //判断是否未管理员
        isAdmin(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(id + "/adminornot", {
                        params: {
                            token,
                        },
                    })
                    .then((res) => {
                        if (res.data.status == "success") {
                            //判断是管理员，还是兼职的
                            resolve(1);
                        } else reject();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //获取所有编辑标签
        // /moas/work/tag
        getEditorTags(params) {
            return new Promise((resolve, reject) => {
                axIns.get(`/moas/work/tag`).then((response) => {
                    resolve(response.data.data);
                });
            });
        },
        //审核
        /*
            pass {bool} 是否通过审核
            delete {bool} 处理举报
            reason {string} 处理原因
            title {string} 标题
            description {string} 描述
            member_free {bool} 会员免费
            tag {Array} 标签
            atag {Array} 编辑标签id数组
            lang {enum} 地区 {CN|EN|FR|DE|JP|ES|RU}
            keyword {String} 关键字
        */
        reviewFile(params, type) {
            let { id, token, workId } = params,
                payload;
            if (type == "modify") {
                let { title, description, tag, keyword, member_free, atag, lang, album, seo_title, seo_content, seo_photo, seo_alt } = params;
                payload = {
                    title,
                    description,
                    tag,
                    lang,
                    keyword,
                    member_free,
                    atag,
                    seo_title,
                    seo_content,
                    seo_photo,
                    seo_alt,
                };
                if (album) {
                    payload["album"] = album;
                }
            } else if (type == "review") {
                let { reason, pass, outline, lang } = params;
                payload = {
                    pass,
                    reason,
                    outline,
                    lang,
                };
            } else if (type == "report") {
                let { reason, del, lang } = params;
                payload = {
                    delete: del,
                    reason,
                    lang,
                };
            }
            return new Promise((resolve, reject) => {
                baseAxIns
                    .put(`manager/${id}/review/work/${workId}`, payload, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject();
                    });
            });
        },
        reviewAndPublishFile(params, type) {
            let {
                    id,
                    token,
                    workId,
                    title,
                    description,
                    tag,
                    keyword,
                    member_free,
                    atag,
                    score,
                    lang,
                    reason,
                    pass,
                    album,
                    seo_title,
                    seo_content,
                    seo_photo,
                    seo_alt,
                    cover_height,
                    cover_width,
                } = params,
                payload;
            payload = {
                title,
                description,
                tag,
                lang,
                keyword,
                member_free,
                atag,
                score,
                pass,
                seo_title,
                seo_content,
                seo_photo,
                seo_alt,
            };
            if (album) {
                payload["album"] = album;
            }
            if (cover_height) {
                payload["cover_height"] = cover_height;
                payload["cover_width"] = cover_width;
            }
            return new Promise((resolve, reject) => {
                baseAxIns
                    .put(`manager/${id}/review/work/${workId}`, payload, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject();
                    });
            });
        },
        getManagerToken(params) {
            let { id, work_id, token } = params;
            // /api/manager/{id}/work/{work_id}/obj
            return new Promise((resolve, reject) => {
                baseAxIns.get(`manager/${id}/work/${work_id}/obj?token=${token}`).then((res) => {
                    resolve(res);
                });
            });
        },
        updateEDDX(path, fileData) {
            let url = window["GLOBAL"].PRIVATE_OSS_HOST + path;
            return new Promise((resolve, reject) => {
                axios
                    .put(url, fileData, {
                        headers: {
                            "Content-Type": "application/octet-stream",
                        },
                    })
                    .then(function (res) {
                        if (res.statusText === "OK") {
                            resolve();
                        }
                    })
                    .catch((error) => {
                        reject();
                    });
            });
        },
        // 根据用户id，给指定用户发消息
        sendNotify(params) {
            let { userIds, id, token, content } = params;
            return new Promise((resolve) => {
                masterAxios
                    .post(
                        `${id}/admin/sendnotify`,
                        {
                            ids: userIds,
                            content,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve();
                    });
            });
        },
        /**  /moas/worktask/{id}/check/{work_id}
            修改作品信息
            info :{
                status: number 0(默认) 1(已处理) 2(pass) 3(下架)，
                reason: string
                tags: Array<number> editorTags ids
                change: Object {title:|description:|score}
            }
        */
        changeWorkInfo(params) {
            let { id, token, work_id, info } = params;
            return new Promise((resolve, reject) => {
                axios
                    .post(`https://test.edrawsoft.cn/viewer/public/moas/worktask/${id}/check/${work_id}`, info, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve();
                    });
            });
        },
        //浏览量、举报
        // /api/work/{work_id}
        viewOrReportWork(params) {
            let { id, workId, preview, report, report_type } = params,
                param;
            if (preview)
                param = {
                    pv: preview,
                    user_id: id,
                };
            else if (report)
                param = {
                    report,
                    report_type,
                };
            return new Promise((resolve, reject) => {
                baseAxIns.put("work/" + workId, param).then((res) => {
                    if (res.data.status == "success") resolve();
                    else reject(res.data);
                });
            });
        },
        //赞、踩、收藏
        ///api/user/{user_id}/attr
        likeOrCollectWork(params) {
            let { id, token, workId, like, dislike, collect } = params;
            return new Promise((resolve) => {
                userAxIns
                    .post(
                        id + "/attr",
                        {
                            id: workId,
                            like,
                            dislike,
                            collect,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then(() => {
                        resolve();
                    });
            });
        },
        // --------------------------------------------------------tag-----------------------------------------
        //标签联想
        // /api/tag/suggestion
        tagSuggestion(params) {
            let { id, token, tag } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get("tag/suggestion", {
                        params: {
                            names: [tag],
                            token,
                            id,
                            lang,
                        },
                    })
                    .then((res) => {
                        let tagData = {};
                        tagData.suggestTags = res.data.data;
                        if (res.data.msg) {
                            let resArr = res.data.msg.split(",");
                            let invalid = resArr[0] == "invalid";
                            if (invalid) {
                                resArr.shift();
                                tagData.blacklist = resArr;
                            }
                        }
                        resolve(tagData);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //获取收藏和点赞的作品
        // /api/user/{user_id}/attr/{type}
        getLikeAndCollectWorks(params) {
            let { id, token, type } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(id + "/attr/" + type, {
                        params: {
                            token,
                            lang,
                            count: 100,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //获取标签分类
        getTagClass(params) {
            return new Promise((resolve, reject) => {
                let url = "max/tag";
                params && (url = `max/tag?group=default&lang=${params.lang}`);
                baseAxIns
                    .get(url)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getRoleClass(params) {
            return new Promise((resolve, reject) => {
                let url = "max/tag?group=role";
                params && (url = `max/tag?group=role&lang=${params.lang}`);
                baseAxIns
                    .get(url)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // --------------------------------------------------suggestion-------------------------------
        getUserSuggestionById(params) {
            let { id, token, userId, type } = params;
            return new Promise((resolve, reject) => {
                axIns
                    .get(`/moas/workint/manager/${id}/recommend`, {
                        params: {
                            token,
                            user_id: userId,
                            type,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        updateUserSuggestion(params) {
            let { id, token, user_id } = params;
            return new Promise((resolve) => {
                axIns
                    .put(
                        `/moas/workint/manager/${id}/recommend`,
                        {
                            user_id: user_id,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data.data);
                    });
            });
        },
        //获取已购买的作品数据
        // /api/user/:id/work/bought
        getBoughtWorks(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                if (!id || !token) {
                    reject();
                }

                userAxIns
                    .get(id + "/work/bought", {
                        params: {
                            token,
                            offset: 0,
                            count: 1000,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //获取用户画像
        getUserInterests(params) {
            let { id, token, userId, type } = params;
            return new Promise((resolve, reject) => {
                axIns
                    .get(`/moas/workint/manager/${id}/info`, {
                        params: {
                            token,
                            user_id: userId,
                            type,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // --------------------------------------提现相关------------------------------------
        //获取所有提现申请
        //（后台管理）获得所有用户反馈/api/user/:id/money/application
        getWithdrawApplications(params) {
            let { id, token, userId, account } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(id + "/money/application?token=" + token, {
                        params: {
                            userId,
                            account,
                        },
                    })
                    .then((res) => {
                        if (res.data.status == "success") {
                            resolve(res.data.data);
                        } else {
                            reject();
                        }
                    });
            });
        },
        //记录打款信息
        ///api/user/:id/money/:money_id
        handleWithdraw(params) {
            let { id, token, withdrawId, result, remark } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(
                        id + "/money/" + withdrawId,
                        {
                            result,
                            remark,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        if (res.data.status == "success") {
                            resolve(res.data.data);
                        } else {
                            reject();
                        }
                    });
            });
        },
        // --------------------------------------用户反馈相关------------------------------------
        //（后台管理）获得所有用户反馈
        getFeedbacks(params) {
            let { id, user_id, type, handled, offset, count } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(id + "/feedback", {
                        params: {
                            user_id,
                            type,
                            handled,
                            offset,
                            count,
                        },
                    })
                    .then((res) => {
                        if (res.data.status == "success") {
                            resolve(res.data.data);
                        } else {
                            reject();
                        }
                    });
            });
        },
        //处理反馈
        handleFeedback(params) {
            let { id, token, feedbackId, reply, ignore } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .put(
                        id + "/feedback/" + feedbackId,
                        {
                            reply,
                            ignore,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // --------------------------------------关注粉丝相关------------------------------------
        // 关注/取消关注
        // {post} /api/user/:id/focus
        follow(params) {
            let { id, token, follow, focus_id } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(
                        `${id}/focus`,
                        {
                            focus_id,
                            f: follow,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then(() => {
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //获取所有关注者和粉丝
        // {get} /api/user/:id/focus
        getRelationships(params) {
            let { id } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/focus`)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // --------------------------------------兴趣相关------------------------------------
        //获取自己的兴趣
        getOwnInterest(params) {
            let { id, token, choose } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(id + "/workint/list", {
                        params: {
                            token,
                            choose,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //设置自己的兴趣
        setOwnInterest(params) {
            let { id, token, ids } = params;
            return new Promise((resolve) => {
                userAxIns
                    .post(
                        `${id}/workint`,
                        {
                            ids,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then(() => {
                        resolve();
                    });
            });
        },
        //删除自己的兴趣
        deleteOwnInterest(params) {
            let { id, token, ids } = params;
            return new Promise((resolve) => {
                userAxIns
                    .post(
                        `${id}/workint/delete`,
                        {
                            ids,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then(() => {
                        resolve();
                    });
            });
        },
        // --------------------------------------未分类------------------------------------
        //获取某个用户发布的所有作品
        getUserWorks(params) {
            let { id, offset, count, order, sort, lang } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get("user/" + id + "/work", {
                        params: {
                            offset,
                            count,
                            order,
                            sort,
                            lang,
                        },
                    })
                    .then((res) => {
                        let data = res.data;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //获取用户的基础信息
        getUserBasicInfo(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                userDataIns
                    .get(id + "/basic?token=" + token)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getTplRecommendWords(params) {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get("max/work/recommend/words", { params: params })
                    .then((res) => {
                        let data = res.data.data;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // Publish - 获取所有发布和公开的内容
        getPublish(params) {
            let { offset, count, order, price, sort, tag, classId, tagId, lang, album } = params,
                path = "publish";
            let obj = {
                offset,
                count,
                order,
                sort,
                "tag[]": tag,
                lang,
                classId,
                tagId,
                price,
            };
            if (params.user_id) {
                obj.user_id = params.user_id;
            }

            if (classId && tag.length == 0) {
                path = "publish2";
            }
            if (params.search && tag.length == 0) {
                obj.search = params.search;
            }
            if (album) {
                obj.album = album;
            }
            if (params.order == "FOLLOW") {
                path = `user/${params.user_id}/focwork`;
                obj.order = "TIME";
                obj.token = params.token;
                return new Promise((resolve, reject) => {
                    baseAxIns
                        .get(path, {
                            params: obj,
                        })
                        .then((res) => {
                            let data = res.data.data;
                            resolve({
                                data,
                                total: res.data.msg,
                            });
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            }
            if (params.order == "HOT") {
                path = `publish/hotwork`;
                return new Promise((resolve, reject) => {
                    baseAxIns
                        .get(path, {
                            params: obj,
                        })
                        .then((res) => {
                            let data = res.data.data;
                            resolve({
                                data,
                                total: res.data.msg,
                            });
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            }
            if (params.template_type) {
                obj.template_type = params.template_type;
            }
            let timeout = app.isPC ? 20 * 1000 : 10 * 1000;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(path, {
                        params: obj,
                        timeout,
                    })
                    .then((res) => {
                        let data = res.data.data;
                        resolve({
                            data,
                            total: res.data.msg,
                        });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getSearchHotkey(params) {
            let { lang, count } = params;
            return new Promise((rs, rj) => {
                // axios.get(`http://10.10.17.37:8011/api/max/work/search/hot?lang=${lang}&count=${count}`).then(e => {
                baseAxIns.get(`max/work/search/hot?lang=${lang}&count=${count}`).then((e) => {
                    let arr = [];
                    if (e.data.data.length > 0) {
                        arr = e.data.data.map((v, k) => {
                            return {
                                id: k,
                                name: v,
                            };
                        });
                    }
                    rs(arr);
                });
            });
        },
        // -----------------------------------------编辑分类-------------------------------
        getTagsIconLink(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`manager/${id}/icon/tag`, {
                        params: {
                            token: token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getClassifyList(params) {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`max/tag`)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        addClassify(params) {
            let { id, token, data } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(`manager/${id}/tag`, data, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        delClassify(params) {
            let { id, token, data } = params;
            let tagStr = "";
            for (let v of data.target_ids) {
                tagStr += `target_ids[]=${v}`;
            }
            return new Promise((resolve, reject) => {
                baseAxIns
                    .delete(`manager/${id}/tag?${tagStr}&isTag=${data.isTag}`, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        updateClassify(params) {
            let { id, token, data } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .patch(`manager/${id}/tag`, data, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        orderClassify(params) {
            let { id, token, data } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(`${id}/tagcls/sort`, data, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        addInterestWhenClone(params) {
            let { id, token, workId } = params;
            return new Promise((resolve) => {
                userAxIns
                    .post(
                        id + "/attr",
                        {
                            id: workId,
                            used: 1,
                            // like,
                            // dislike,
                            // collect
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then(() => {
                        resolve();
                    });
            });
        },
        //克隆作品到个人目录
        cloneFile(params) {
            let { id, token, workId, member, type, platform } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(id + "/work/" + workId + "?token=" + token, {
                        params: {
                            member,
                            type,
                            platform,
                            t: new Date().getTime(),
                        },
                    })
                    .then((res) => {
                        let result = res.data;
                        if (result.status == "success") {
                            //online克隆成功后，返回该作品克隆到云文件中之后，该云文件的object(filekey)
                            if (result.data.object) {
                                resolve(result.data);
                            } else {
                                //pc端克隆会员免费作品时，会用到这个接口，成功会返回作品的下载信息
                                resolve(result.data);
                            }
                        } else {
                            reject(result.msg);
                        }
                    })
                    .catch((error) => {
                        if (error.response.data.space == "You do not have enough space.") {
                            reject(error.response.data.space);
                        }
                    });
            });
        },
        checkOrder(params) {
            // let { id, orderId } = params;
            // return new Promise((resolve, reject) => {
            //     userDataIns
            //         .get(id + "/max/workorder/" + orderId)
            //         .then(res => {
            //             resolve(res.data.data);
            //         })
            //         .catch(err => {
            //             reject(err);
            //         });
            // });
            // 新的轮询接口
            let { code } = params;
            return new Promise((resolve, reject) => {
                axIns
                    .get("/api/work/order", {
                        params: {
                            license: "max-work",
                            pay_code: code,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 下单
        submitOrder(params) {
            // let { id, token, type, workId } = params;
            // return new Promise((resolve, reject) => {
            //     userDataIns
            //         .post(
            //             id + "/max/work/" + workId,
            //             {
            //                 payment: type
            //             },
            //             {
            //                 headers: {
            //                     Authorization: "Bearer " + token
            //                 }
            //             }
            //         )
            //         .then(res => {
            //             resolve(res.data.data);
            //         })
            //         .catch(err => {
            //             reject(err);
            //         });
            // });
            let { id, token, work_id } = params;
            return new Promise((resolve, reject) => {
                userDataIns
                    .get(id + "/access/paycode", {
                        params: {
                            token,
                            work_id,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 兼职人员后台
        /**
         * @api {​​​​​​​​get}​​​​​​​​ /api/manager/{​​​​​​​​id}​​​​​​​​/worklist 获取作品列表
         * @apiGroup WorkCheck
         *
         * @apiParam  {​​​​​​​​int}​​​​​​​​ offset 可省略
         * @apiParam  {​​​​​​​​int}​​​​​​​​ count  可省略
         * @apiParam {​​​​​​​​Enum}​​​​​​​​ lang zh|en|fr|de|jp|es|ru
         * @apiParam  {​​​​​​​​array}​​​​​​​​ work_ids  作品id数组
         * @apiParam  {​​​​​​​​boolean}​​​​​​​​ review_tmp 获取修改过的作品, 0|1
         * @apiParam  {​​​​​​​​String}​​​​​​​​ review_status 筛选审核状态，pass,pending,reject
         */
        /**
         * @api {​​​​​​​​post}​​​​​​​​ /api/manager/{​​​​​​​​id}​​​​​​​​/worktmp/{​​​​​​​​work_id}​​​​​​​​ 更新作品到缓存
         * @apiGroup WorkCheck
         *
         * @apiParam  {​​​​​​​​String}​​​​​​​​ lang  CN|EN|...,可省略默认为CN
         * @apiParam  {​​​​​​​​string}​​​​​​​​  description  作品描述
         * @apiParam  {​​​​​​​​string}​​​​​​​​  title  标题
         */
        /**
         * @api {​​​​​​​​put}​​​​​​​​ /api/manager/{​​​​​​​​id}​​​​​​​​/worktmp/{​​​​​​​​work_id}​​​​​​​​ 处理缓存
         * @apiGroup WorkCheck
         *
         * @apiParam  {​​​​​​​​String}​​​​​​​​ status pass|reject
         * @apiParam  {​​​​​​​​String}​​​​​​​​ reason 可省略
         * @apiParam  {​​​​​​​​Enum}​​​​​​​​ lang zh|en|fr|de|jp|es|ru
         */
        /**
         * @api {get} /api/manager/{id}/role  获取用户身份权限
         * @apiGroup WorkCheck
         */

        getAllReviewRoles(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`manager/${id}/role`, {
                        params: { token },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getAllReviewWorks(params) {
            let { id, token, offset, count, lang, work_id, review_tmp, review_status } = params;
            let pp = {
                offset,
                count,
                lang,
                token,
            };
            if (review_tmp != null) {
                Object.assign(pp, { review_tmp });
            }
            if (work_id) {
                Object.assign(pp, { work_ids: work_id });
            }
            if (review_status) {
                Object.assign(pp, { review_status });
            }
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`manager/${id}/worklist`, {
                        params: pp,
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        updateWorkInfo(params) {
            let { id, token, lang, description, title, work_id, tag, atag } = params;
            let pp = {
                tag,
                atag,
                description,
                title,
                lang,
            };
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(`manager/${id}/worktmp/${work_id}`, pp, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        updateWorkStatus(params) {
            let { id, token, work_id, status, reason, lang } = params;
            let pp = {
                lang,
            };
            if (status) {
                Object.assign(pp, { status });
            }
            if (reason) {
                Object.assign(pp, { reason });
            }
            return new Promise((resolve, reject) => {
                baseAxIns
                    .put(`manager/${id}/worktmp/${work_id}`, pp, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        // -----------------------------------------举报后台-------------------------------
        getReported(params) {
            let { id, token, offset, count } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/report`, {
                        params: {
                            offset,
                            count,
                            token,
                            lang,
                        },
                    })
                    .then((res) => {
                        let data = res.data.data;
                        resolve({ data, total: res.data.msg });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        // album
        getAlbumList(params) {
            // 获取专辑列表
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`/max/album`, {
                        params,
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getAlbumByID(params) {
            // 查看某专辑
            let { album_id } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`/max/album/${album_id}`)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        addAlbum(params) {
            // 新增专辑
            let { title, description, lang, user_id, token, sort } = params;
            return new Promise((resolve, reject) => {
                let param = {
                    title,
                    description,
                    lang,
                };
                if (sort) {
                    param["sort"] = sort;
                }
                baseAxIns
                    .post(`/max/manager/${user_id}/album`, param, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        delAlbum(params) {
            // 删除专辑
            let { user_id, token, album_id } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .delete(`max/manager/${user_id}/album/${album_id}`, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        updateAlbum(params) {
            // 更新专辑信息
            let { user_id, token, album_id, data } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .patch(`max/manager/${user_id}/album/${album_id}`, data, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        uploadAlbumCover(params) {
            // 获取专题封面签名
            let { user_id, token, album_id } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .put(
                        `max/manager/${user_id}/album/${album_id}/cover`,
                        {},
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        OCRIdentify({ formData, user_id, token }) {
            // OCR文字识别
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(`ocr/${user_id}/identify`, formData, {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        EditUserInfor(loginfor, params, userInfo) {
            let userId = loginfor.id,
                token = loginfor.token,
                postparams = Object.assign(params);
            return new Promise((resolve, reject) => {
                userDataIns
                    .put(userId.toString(), postparams, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetEditImgSign(loginfor, type) {
            let userId = loginfor.id,
                token = loginfor.token;
            return new Promise((resolve, reject) => {
                userDataIns
                    .post(
                        `avatar2/${userId.toString()}`,
                        { type: type },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        sendPersonalImg(pathInfor, ImgBlob) {
            let url;
            if (internal)
                url = `${window["GLOBAL"].PUBLIC_OSS_HOST}/${pathInfor.path}?OSSAccessKeyId=${OSSAccessKeyId}&Expires=${
                    pathInfor.exp
                }&Signature=${encodeURIComponent(pathInfor.sign)}`;
            else
                url = `${window["GLOBAL"].PUBLIC_OSS_HOST.substr(0, window["GLOBAL"].PUBLIC_OSS_HOST.length - 1)}${pathInfor.path}?${
                    pathInfor.query
                }`;
            return new Promise((resolve, reject) => {
                axios
                    .put(url, ImgBlob, {
                        headers: {
                            "Content-Type": "application/octet-stream",
                            // "Content-Type": "image/png"
                        },
                    })
                    .then(function (res) {
                        if (res.statusText === "OK") {
                            resolve(res);
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        checkPromotion(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                userDataIns
                    .get(id + "/promocode?token=" + token)
                    .then(({ data }) => {
                        let filterd = data.data.filter((item) => item.type == 2 && item.satisfy == 5000 && item.value == 3000);
                        resolve(Boolean(filterd.length));
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        //---------------- 用户主页  -------------------------------
        getSelfWorks(params) {
            // /api/user/{id}/selfwork
            let { id, token, status, platform } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get("user/" + id + "/selfwork", {
                        // axios.get('http://10.10.17.37:8010/api/user/' + id + "/selfwork", {
                        params: {
                            token,
                            status,
                            platform,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //获取用户的基础信息
        getIntervieweeInfo(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                userDataIns
                    .get(id + "/basic")
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //获取某个用户发布的所有作品
        getIntervieweeWorks(params) {
            let { id, offset, count, order, sort, lang } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get("user/" + id + "/work", {
                        params: {
                            offset,
                            count,
                            order,
                            sort,
                            lang,
                        },
                    })
                    .then((res) => {
                        let data = res.data;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // 获取用户收藏的模板
        getIntervieweeCollectWorks(params) {
            let { id, offset, count, order, sort, lang } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get("user/" + id + "/attr/collect", {
                        params: {
                            offset,
                            count,
                            order,
                            sort,
                            lang,
                        },
                    })
                    .then((res) => {
                        let data = res.data;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        submitFeedback(params) {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post("edmax/template/feedback", params)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        geUploadLink() {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get("edmax/template/feedback/policy")
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getActivity(params) {
            let { position, lang, platform, token, pid } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get("activity", {
                        // axios.get("http://10.10.17.39:8010/api/user/activity", {
                        params: {
                            position,
                            platform,
                            lang,
                            token,
                            pid,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getNalPromo(params) {
            // /api/user/{id}/terminalpromo/grab
            // positions: 位置: 1-购物车贴片左边 2-新建页中间 3-新建页右下角 4-编辑页中间 5-编辑页右下角 (不传或传空值则默认获取所有)
            let { user_id: id, token, lang, positions, v } = params;
            if (lang == "zh") {
                lang = "cn";
            }
            return new Promise((s, j) => {
                userDataIns
                    .get(`${id}/terminalpromo/grab`, {
                        params: {
                            token,
                            lang,
                            picture_type: 1,
                            product: "max",
                            platform: "web",
                            positions,
                            v,
                        },
                    })
                    .then((res) => {
                        s(res);
                    });
            });
        },
        putAiPromo(params) {
            const { user_id: id, token } = params;
            if (!id) {
                return;
            }

            return new Promise((resolve, reject) => {
                userDataIns
                    .put(
                        `${id}/aipromo/receive`,
                        {
                            event: 5,
                            status: 2,
                            product: "max",
                            platform: "web",
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getVideo(params) {
            // ToDo 硬编码
            let url = "https://pixsoapi.edrawsoft.cn/api/helpcenter/draw/tutorial/list";
            if (isPrivate) {
                url = `${helpcenterUrl}/api/helpcenter/draw/tutorial/list`;
            }
            return new Promise((resolve, reject) => {
                axios
                    .get(url, {
                        params: params,
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        addTemplateHistory(params) {
            // 上传模板分类记录
            let { user_id, token, data } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .post(`${user_id}/template/history`, data, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getSubClassHistory(params) {
            // 获取三级分类记录
            let { user_id, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${user_id}/template/history/subclass`, {
                        params: {
                            token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getTemplateHistory(params) {
            // 获取模板记录
            let { user_id, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${user_id}/template/history`, {
                        params: {
                            token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // my template
        getCustomTemplateList(params) {
            // 获取个人模板列表
            let { user_id, token, offset, count, search } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${user_id}/max/obj/template/list`, {
                        params: {
                            token,
                            offset,
                            count,
                            search,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
            });
        },
        addCustomTemplate(params) {
            // 添加个人模板
            let { user_id, token, data } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${user_id}/max/obj/template`, data, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.status);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        deleteCustomTemplate(params) {
            // 删除个人模板
            let { user_id, token, template_ids, tpl_file_keys } = params;
            let p = {
                template_ids,
            };
            if (isPrivate) {
                Object.assign(p, {
                    tpl_file_keys,
                });
            }
            return new Promise((resolve, reject) => {
                ossAxIns
                    .delete(`${user_id}/max/obj/template`, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                        params: p,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        useCustomTemplateSign(params) {
            // 获取个人模板签名
            console.log("params", params);
            let { user_id, token, template_id, platform, tpl_file_key } = params;
            let obj = {
                template_id,
                platform,
            };
            if (isPrivate) {
                Object.assign(obj, { tpl_file_key });
            }
            return new Promise((resolve, reject) => {
                ossAxIns
                    .post(`${user_id}/max/obj/template/clone`, obj, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadCustomTemplate(params) {
            let { user_id, data } = params;
            return new Promise((resolve, reject) => {
                ossAxIns
                    .get(`${user_id}/max/obj/template`, {
                        params: data,
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getCoupon(params) {
            // /api/user/{id}/selfwork
            let { user_id, code, token } = params;
            return new Promise((resolve, reject) => {
                axIns
                    .post(
                        "/api/user/" + user_id + "/promo/bind",
                        {
                            code,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                                "Content-Type": "application/json",
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getSmartCoupon(params) {
            let { id, token, lang } = params;
            return new Promise((rs, rj) => {
                userDataIns
                    .get(`${id}/smartpromo/grab`, {
                        params: {
                            token,
                            lang,
                            platform: "web",
                            picture_type: 1,
                        },
                    })
                    .then((res) => {
                        rs(res);
                    })
                    .catch((err) => {
                        rj(err);
                    });
            });
        },
        readSmartCoupon(params) {
            let { id, token, code } = params;
            return new Promise((res, rej) => {
                userDataIns
                    .put(
                        `${id}/smartpromo/read`,
                        {
                            code,
                            status: 2,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        res(res.data);
                    })
                    .catch((err) => {
                        rej(err);
                    });
            });
        },
        // inclowdz
        getAccessToken(params) {
            // /api/ws/access_token
            let { access_token, lang } = params;
            return new Promise((resolve, reject) => {
                axIns
                    .post(
                        "/api/ws/access_token",
                        {
                            access_token,
                            product: "edrawmax",
                            lang,
                            client_type: "ONLINE",
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadInclowdzFile(url) {
            return new Promise((res, rej) => {
                axios.get(url, { responseType: "blob" }).then((response) => {
                    res(response.data);
                });
            });
        },
        getTemplateSign(params) {
            let { type, tid } = params;
            let url = "max/work/sign",
                obj = {
                    work_id: tid,
                };
            if (type == "0") {
                url = "edmax/template/sign";
                obj = {
                    template_id: tid,
                };
            }
            return baseAxIns.get(url, {
                params: obj,
            });
        },
        getTemplateDownloadSign(params) {
            let { id, token, obj } = params;
            return userAxIns.get(`${id}/work/sign?token=${token}`, {
                params: obj,
            });
        },
        reportShareFile(uuid) {
            return new Promise((res, rej) => {
                baseAxIns
                    .put(`share/max/${uuid}`, {
                        type: "REPORT",
                        act: "PLUS",
                    })
                    .then((response) => {
                        res(response.data);
                    })
                    .catch((err) => {
                        rej(err);
                    });
            });
        },
        getShareType({ uuid, user_id, email, access_code }) {
            return new Promise((res, rej) => {
                let query = "";
                if (user_id) query = `&user_id=${user_id}`;
                if (email) query += `&email=${email}&access_code=${access_code}`;
                baseAxIns
                    .get(`share/max/pwd/status?uuid=${uuid}${query}`)
                    .then((response) => {
                        res(response.data);
                    })
                    .catch((err) => {
                        rej(err);
                    });
            });
        },
        getShareFileInfo({ code, pwd, user_id, platform }) {
            return new Promise((res, rej) => {
                let query = "";
                if (user_id) query = `&user_id=${user_id}&platform=${platform}`;
                baseAxIns
                    .get(`share/max/${code}?pwd=${pwd}${query}`)
                    .then((response) => {
                        res(response.data);
                    })
                    .catch((err) => {
                        rej(err);
                    });
            });
        },
        likeOrReportShareFile(data, code) {
            return new Promise((res, rej) => {
                baseAxIns
                    .put(`share/max/${code}`, data)
                    .then((response) => {
                        res(response.data);
                    })
                    .catch((err) => {
                        rej(err);
                    });
            });
        },
        getFileLockInfo({ user_id, code, token, platform }) {
            return new Promise((res, rej) => {
                baseAxIns
                    .put(
                        `user/${user_id}/max/share/edit/${code}/lock`,
                        { platform },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        res(response);
                    })
                    .catch((err) => {
                        rej(err);
                    });
            });
        },
        fileUnLock({ user_id, code, token }) {
            return new Promise((res, rej) => {
                baseAxIns
                    .post(`user/${user_id}/max/share/edit/${code}/release/${token}`)
                    .then((response) => {
                        res(response);
                    })
                    .catch((err) => {
                        rej(err);
                    });
            });
        },
        getUptLog() {
            let url = "https://pixsoapi.edrawsoft.cn/api/helpcenter/draw/uptlog";
            if (isPrivate) {
                url = `${helpcenterUrl}/api/helpcenter/draw/uptlog`;
            }
            return new Promise((resolve, reject) => {
                axios
                    .get(url, {
                        params: {
                            product: 2,
                            platform: 1,
                            only_ver: false,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getVipFirst(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                userDataIns
                    .get(`${id}/work/vipfirst`, {
                        params: {
                            token,
                            type: "max",
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        useVipFirst(params) {
            let { id, token, work_id } = params;
            return new Promise((resolve, reject) => {
                userDataIns
                    .post(
                        `${id}/work/vipfirst`,
                        {
                            work_id,
                            type: "max",
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res.data.status == "success");
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getSpecialTags(lang) {
            return new Promise((resolve, reject) => {
                userAxIns
                    .get("collection/list", {
                        params: {
                            offset: 0,
                            count: 100,
                            lang,
                        },
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getWorkSeoimgSign(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`manager/${id}/review/work/policy`, {
                        params: { token },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getSpecialTagsInfo(params) {
            const { lang, tag_id } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get("tag/info", {
                        params: {
                            tag_id,
                            lang,
                        },
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getTrendingSearch(params) {
            const { lang } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get("collection/trending", {
                        params: {
                            lang,
                            offset: 0,
                            count: 30,
                        },
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        setThumbSize(params) {
            let { id, token, workId, lang, cover_width, cover_height } = params;
            let payload = {
                cover_width,
                cover_height,
                lang,
            };
            return new Promise((resolve, reject) => {
                baseAxIns
                    .put(`manager/${id}/review/work/${workId}`, payload, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject();
                    });
            });
        },
        getUserRoles(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`manager/${id}/role?token=${token}`)
                    .then((response) => {
                        if (response.data) {
                            resolve(response.data);
                        } else {
                            reject();
                        }
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        setShareUsable(params) {
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(`/user/${id}/max/share/switch`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        inviteMember(params) {
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(`/user/${id}/max/share/initiate`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        verifyPhone(params) {
            let { id, token } = params;
            delete params.id;
            delete params.token;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(`/user/${id}/max/share/verify`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        if (res.data.status === "success") {
                            resolve();
                        } else {
                            reject(res.data.msg);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getMembers(params) {
            let { id, shareId, token } = params;
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${id}/max/share/member?token=${token}&share_id=${shareId}`)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        bindUserPhone(params) {
            let { token, mobile, code } = params;
            return new Promise((resolve, reject) => {
                goApiAxios
                    .post(
                        `ws/bind-mobile`,
                        { mobile, code },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status === "success") {
                            resolve();
                        } else {
                            reject(response.data.msg);
                        }
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getPhoneCode(params) {
            let { user_id, captcha_type, mobile } = params;
            return new Promise((resolve, reject) => {
                goApiAxios
                    .get(`ws/mobile-captcha/send`, {
                        params: {
                            user_id,
                            captcha_type,
                            mobile,
                        },
                    })
                    .then((response) => {
                        if (response.data.status === "success") {
                            resolve();
                        } else {
                            reject(response.data.msg);
                        }
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getMedalIds() {
            return new Promise((res, rej) => {
                axIns
                    .post("/api/medal/expert", { products: [2] })
                    .then((response) => {
                        res(response.data.data);
                    })
                    .catch((err) => {
                        rej(err);
                    });
            });
        },
        getUserMedal(user_ids) {
            return new Promise((res, rej) => {
                axIns
                    .post("/api/medal/users", {
                        user_ids,
                        products: [2],
                    })
                    .then((response) => {
                        res(response.data.data);
                    })
                    .catch((err) => {
                        rej(err);
                    });
            });
        },
        /***新手任务 */
        getUserTaskList(params) {
            // /api/user/{id}/novice/task
            let { user_id: id } = params;
            return new Promise((resolve, reject) => {
                delete params.user_id;
                userAxIns
                    .get(`${id}/novice/task`, {
                        params,
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    });
            });
        },
        completeUserTask(params) {
            // /api/user/{id}/novice/task
            let { user_id: id, token } = params;
            return new Promise((resolve, reject) => {
                delete params.user_id;
                delete params.token;
                userAxIns
                    .put(`${id}/novice/task`, params, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    });
            });
        },
        completeUserQuestion(params) {
            // /api/user/{id}/novice/survey
            let { user_id: id, token } = params;
            return new Promise((resolve, reject) => {
                delete params.user_id;
                delete params.token;
                userAxIns
                    .post(`${id}/novice/survey`, params, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data);
                    });
            });
        },
        /*** 抵用金 */
        getCredit(params) {
            let { id, token } = params;
            return axIns.get(`/api/user/${id}/coupontemplate?token=${token}`);
        },
        useCredit(params) {
            let { token } = params;
            return axIns.post(`/api/work/placeorderbycoupon`, params, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
        },
        getPoints(userInfo) {
            if (window.EDCONFIG.IS_SDK) {
                return app.sdkApp.promisePostMessage("GET_AI_POINTS");
            }
            let { token, user_id } = userInfo;
            return new Promise((resolve, reject) => {
                userDataIns
                    .get(`${user_id}/points?token=${token}`)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((e) => {
                        reject(e);
                    });
            });
        },
        txtVerify(params, isDev) {
            let { token, text, uid } = params;
            // if (isDev) {
            //     // 测试环境地址
            //     goRiskAxios = axios.create({
            //         baseURL: "http://dev.edrawmax.cn/api/risk",
            //         withCredentials: false,
            //     });
            // }

            if (window.EDCONFIG.IS_SDK) {
                return app.sdkApp.promisePostMessage("POST_AI_TEXT_VERIFY", { text, uid });
            }

            return new Promise((resolve, reject) => {
                goRiskAxios
                    .post(
                        "/baiduAI/user/txtVerify",
                        { text, uid },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((e) => {
                        reject(e);
                    });
            });
        },
        getPublishPrice() {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`edmax/template/price/config`)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getAIActivePoints() {
            return new Promise((resolve, reject) => {
                axIns
                    .get(`/api/points/marketing`)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getAppConfig(params) {
            let { user_id } = params;
            return axIns.get(`/api/user/${user_id}/config`, {
                params,
            });
        },
        getAIOpenRecord(params) {
            let { user_id, token } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`/ai/${user_id}/first?token=${token}`)
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getOssAccessID() {
            return baseAxIns.get("edmax/oss/sign/info", {
                params: {
                    acl: "pub", // pub-公共 pri-私有
                },
            });
        },
        getPriOssAccessID() {
            return baseAxIns.get("edmax/oss/sign/info", {
                params: {
                    acl: "pri", // pub-公共 pri-私有
                },
            });
        },
        getWorksCount() {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get("/publish/count")
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },

        collectPerformance(param) {
            const { pageType, loadTime, domReadyTime, totalResourceLoadTime, monitorTime, fcpTime, lcpTime, clsScore } = param;
            const params = {
                page_type: pageType,
                page_load_time: loadTime,
                dom_ready_time: domReadyTime,
                resource_load_time: totalResourceLoadTime,
                fcp_time: fcpTime,
                lcp_time: lcpTime,
                cls_score: clsScore,
                monitor_time: monitorTime,
            };
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(`/max/page/speed`, params, {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        getAllTemplates() {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get("/edmax/templatecls/v3")
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },

        getMoreTemplateList() {
            // 获取插入模板列表
            return baseAxIns.get("edmax/templatecls2");
        },
        getMoreTemplate(param) {
            let { class_id } = param;
            // 获取插入模板数据
            return baseAxIns.get("edmax/template", {
                params: {
                    class_id: class_id,
                    type: "class",
                },
            });
        },
        getRecommendClass(param) {
            let { user_id } = param;
            let params = {};
            if (user_id) {
                params = {
                    user_id,
                };
            }
            return baseAxIns.get("edmax/templatecls", {
                params,
            });
        },

        getRecommendTemplates(params) {
            let { id, token, pre_tpl_ids, offset, count } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(
                        `/edmax/${id}/template/grab`,
                        {
                            pre_tpl_ids,
                            offset,
                            count,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                                "Content-Type": "application/json",
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },

        // 游客获取推荐模版
        getRecommendTemplatesNotLogin(params) {
            let { pre_tpl_ids, offset, count } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .post(`/edmax/template/grab`, {
                        pre_tpl_ids,
                        offset,
                        count,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },

        // 游客获取精选推荐、AI 制图 大类默认数据
        getDefaultTemplateNotLogin(params) {
            let { type } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`/edmax/template/class/grab?type=${type}`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },

        getRecommendConfig(params) {
            let { id, token } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`/edmax/${id}/template/urcmd?token=${token}`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        updateRecommendConfig(params) {
            let { id, token, sub_ids } = params;
            console.log("sub_ids888823864");
            return new Promise((resolve, reject) => {
                baseAxIns
                    .put(
                        `/edmax/${id}/template/urcmd`,
                        {
                            sub_ids,
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                                "Content-Type": "application/json",
                            },
                        }
                    )
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getDefaultTemplate(params) {
            let { id, token, type } = params;
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`/edmax/${id}/template/class/grab?token=${token}&type=${type}`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getFeatured() {
            return new Promise((resolve, reject) => {
                baseAxIns
                    .get(`/publish/featured?offset=0&count=50`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        workCloneCheck(user_id, params) {
            return new Promise((resolve, reject) => {
                userAxIns
                    .get(`${user_id}/clone/check`, { params })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        getIconfontData(params) {
            if (window.EDCONFIG.IS_SDK) {
                return app.sdkApp.promisePostMessage("GET_ICONFONT", params);
            }

            return baseAxIns.post("icon/0/search", params);
        },
        getPixabayData(params) {
            const colors = params.colors;
            let colorStr = "";
            if (colors.length > 0) {
                colorStr = `&colors[]=${colors}`;
            }
            let suffix = `image_type=${params.image_type}&orientation=${params.orientation}${colorStr}&q=${params.q}&page=${params.page}&per_page=${params.pageSize}&lang=${params.lang}
            `;

            if (window.EDCONFIG.IS_SDK) {
                return app.sdkApp.promisePostMessage("GET_PIXABAY", `?${suffix}`);
            }

            return baseAxIns.get(`pixabay/search?${suffix}`);
        },
        getTextListData(params) {
            /**
             *  platform string 
                    平台: web-在线端 mobile-移动端 win-Windows端 mac-Mac端 linux-Linux端
                text_type number 
                    类型: 1-PPT文字 2-文字设计
                offset number 
                    偏移
                count number 个数（最大100）
                shape_num number 可选
                    形状个数: -1-智能 2-2项 3-3项 4-4项 1000-多项
            */
            let IParams = Object.assign({}, params, { platform: "web", text_type: 1 });
            return baseAxIns.get("edmax/material/libtext", {
                params: IParams,
            });
        },
        downloadTextEdeFile(params) {
            let { url } = params;
            return new Promise((resolve, reject) => {
                axios.get(url, { responseType: "blob" }).then((e) => {
                    resolve(e);
                });
            });
        },
        setFileEdit(params) {
            let { obj_id, member_edit, token } = params;
            return baseAxIns.put(
                "user/file/member/edit",
                {
                    obj_id,
                    platform: "web",
                    member_edit,
                },
                {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                }
            );
        },
        getBuyModalCloseTimes(user_id, token) {
            return new Promise((resolve, reject) => {
                userDataIns
                    .get(`${user_id}/popup/info`, {
                        params: {
                            popup_name: "EDRAW-618",
                            product: "max",
                            platform: "web",
                            token,
                        },
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        let msg = err.response;
                        reject(msg);
                    });
            });
        },
        setBuyModalCloseTimes(user_id, token) {
            return new Promise((resolve) => {
                userDataIns
                    .post(
                        `${user_id}/popup/close`,
                        {
                            popup_name: "EDRAW-618",
                            product: "max",
                            platform: "web",
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.data && response.data.data.result) {
                            resolve(true);
                        } else if (response.data.status == "error") {
                            resolve(0);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch(() => {
                        resolve(0);
                    });
            });
        },
        getCouponExists(params) {
            return new Promise((resolve) => {
                userDataIns
                    .get(`${params.user_id}/promo/check`, {
                        params: {
                            token: params.token,
                            code: params.code,
                        },
                    })
                    .then((response) => {
                        resolve(response.data.status === "success");
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
        },
        getPurchaseBubble(params) {
            const _lang = lang == "zh" ? "cn" : lang;
            let IParams = Object.assign({}, params, { platform: "web", lang: _lang });
            return axIns.get("api/base/config", {
                params: IParams,
            });
        },
        getGroupRole(params) {
            let { id, token } = params;
            return userAxIns.get(`${id}/max/grouporder`, {
                params: {
                    token,
                },
            });
        },
        getUserTag(params) {
            let { id, token } = params;
            return baseAxIns.get(`edmax/${id}/label/info`, {
                params: {
                    token,
                },
            });
        },
        checkFirstEdit(params) {
            let { id, token } = params;
            return baseAxIns
                .get(`user/${id}/first/edit`, {
                    params: {
                        token,
                    },
                })
                .then((res) => {
                    return res.data.data;
                });
        },
    };
}
